import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {finalize} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderViewService {
  isLoading = new Subject<boolean>();

  constructor() { }

  show(loadingSubject?: Subject<boolean>) {
    if (loadingSubject) {
      return loadingSubject.next(true);
    }
    this.isLoading.next(true);
  }
  private hide(loadingSubject?: Subject<boolean>) {
    if (loadingSubject) {
      return loadingSubject.next(false);
    }

    this.isLoading.next(false);
  }

  executeWithLoader<T>(
    observable: Observable<T>,
    loadingSubject?: Subject<boolean>,
  ) {
    this.show(loadingSubject);

    return observable.pipe(
      finalize(() => {
        this.hide(loadingSubject);
      }),
    );
  }
}
